import React from 'react';
import googlePlayIcon from '../../assets/social/google-play.svg';
import githubIcon from '../../assets/social/github-original.svg';
import linkedinIcon from '../../assets/social/linkedin-original.svg';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" id='contact'>
      <div className="footer__container">
        <h3>Follow me ..</h3>
        <div className="footer__social">
          <a href="https://play.google.com/store/apps/dev?id=5856843886627797851&hl=en&gl=US" className='icon1' target="_blank" rel="noopener noreferrer">
            <img src={googlePlayIcon} alt="Google Play Icon" />
          </a>
          <a href="https://github.com/thakurrajputpankaj" className='icon2' target="_blank" rel="noopener noreferrer">
            <img src={githubIcon} alt="GitHub Icon" />
          </a>
          <a href="https://www.linkedin.com/in/pankajthakurrajput/" className='icon3' target="_blank" rel="noopener noreferrer">
            <img src={linkedinIcon} alt="LinkedIn Icon" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
